module.exports = __webpack_public_path__ + "static/media/HINDUNILVR.55f8def9.txt";